import { SortBy } from "@/domains/liquidity-page/liquidity-page-store"
import { ILiquidityPool } from "@/domains/pools"
import { poolSearch } from "@/domains/pools/pool-search"
import { ILiquidityPoolType } from "@/domains/pools/types"
import { TableProcessor } from "@/domains/table-processor"

export const poolProcessor = (
  pools: Array<ILiquidityPool>,
  search: string | null,
  stakedOnly: boolean,
  showInactivePairs: boolean,
  poolType: ILiquidityPoolType,
  sortBy: SortBy,
) => {
  const processed = TableProcessor({
    rows: pools,
    filters: {
      static: [
        {
          name: "search text",
          field: "*",
          filterFunction: (row: ILiquidityPool) => {
            return poolSearch(row, search)
          },
        },
        {
          name: "pool type",
          field: "*",
          filterFunction: (pool: ILiquidityPool) => {
            if (poolType === "volatile") {
              return pool.type === "volatile"
            } else if (poolType === "stable") {
              return pool.type === "stable"
            }
            return true
          },
        },
        {
          name: "junk pairs (inactive)",
          field: "*",
          filterFunction: (pool: ILiquidityPool) => {
            if (showInactivePairs) {
              return true
            }
            return !pool.tags.includes("junk")
          },
        },
      ],
      dynamic: [
        {
          name: "staked only",
          field: "*",
          filterFunction: (pool: ILiquidityPool) => {
            if (!stakedOnly) {
              return true
            }
            const hasPoolAmount = pool.userBalance > 0n
            const hasStakedAmount = pool.gaugeUserBalance > 0n
            if (hasPoolAmount || hasStakedAmount) {
              return true
            }
            return false
          },
        },
      ],
    },
    sort: sortBy,
  })

  return processed
}
